import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PopupSliceState } from './types';
import { RootState } from 'src/app/store';

const initialState: PopupSliceState = {
  routeStack: [],
};

const popupSlice = createSlice({
  name: 'popupSlice',
  initialState,
  reducers: {
    pushPopupRoute(state, action: PayloadAction<any>) {
      state.routeStack.push(action.payload);
    },
    popPopupRoute(state) {
      state.routeStack = state.routeStack.slice(0, -1);
    },
  },
});

export const { pushPopupRoute, popPopupRoute } = popupSlice.actions;

// Stack selector
export const selectRouteStack = (state: RootState) => state.popup.routeStack;

export default popupSlice.reducer;
